import { LazyQueryExecFunction, OperationVariables } from '@apollo/client'
import { CircularProgress, Collapse, Paper } from '@material-ui/core'
import { useState } from 'react'
import InfiniteScroll from 'react-infinite-scroller'

import { DateObject } from '../../helpers/date'
import {
  MonitoringUpdateAccommodationLayer,
  MonitoringUpdateRatePlanrResponse,
  MonitoringUpdateRoomTypeLayerResponse
} from '../../types/monitoringUpdate'
import AccommodationLayer from './AccommodationLayer'
import ChannelsLayer from './ChannelsLayer'
import RoomTypeLayer from './RoomTypeLayer'
import useStyles from './Styles/MonitoringUpdateBoxRow.Style'

interface MonitoringUpdateBoxRowvProps {
  range: 'TWO_WEEKS' | 'MONTH'
  data: MonitoringUpdateAccommodationLayer
  weekendIndexes: number[]
  showChannels: any
  roomTypeMonitoringUpdate: MonitoringUpdateRoomTypeLayerResponse | undefined
  ratePlanMonitoringUpdate: MonitoringUpdateRatePlanrResponse | undefined
  getMonitoringRoomTypeData: LazyQueryExecFunction<
    {
      getUpdateMonitoringRoomTypeLayer: MonitoringUpdateRoomTypeLayerResponse
    },
    OperationVariables
  >
  getMonitoringRatePlanData: LazyQueryExecFunction<
    {
      getUpdateMonitoringRatePlanLayer: MonitoringUpdateRatePlanrResponse
    },
    OperationVariables
  >
  inventoryTypeAutocomplete: any
  statusAutocomplete: any
  selectedDateInDatePicker: DateObject
  loadingForRoomType: boolean
  loadingForRatePlan: boolean
  accommodationIndex: number
}

export default function MonitoringUpdateBoxRow({
  range,
  data,
  weekendIndexes,
  showChannels,
  roomTypeMonitoringUpdate,
  ratePlanMonitoringUpdate,
  getMonitoringRoomTypeData,
  getMonitoringRatePlanData,
  inventoryTypeAutocomplete,
  statusAutocomplete,
  selectedDateInDatePicker,
  loadingForRoomType,
  loadingForRatePlan,
  accommodationIndex
}: MonitoringUpdateBoxRowvProps) {
  const classes = useStyles()
  const [showRoomType, setShowRoomType] = useState(false)
  const PAGE_SIZE = 5
  const [numberOfVisibleChannels, setnumberOfVisibleChannels] =
    useState(PAGE_SIZE)
  const [numberOfVisibleRoomTypes, setnumberOfVisibleRoomTypes] =
    useState(PAGE_SIZE)
  const [showChannelsLayer, setChannelsLayer] = useState(false)
  const [currentIndex, setCurrentIndex] = useState<number>(-1)
  const [currentIndexAccommodationLayer, setCurrentIndexAccommodationLayer] =
    useState<number>(-1)

  const [currentIndexChannelsLayer, setCurrentIndexChannelsLayer] =
    useState<number>(-1)

  return (
    <Paper className={classes.paper} elevation={5}>
      <div>
        <AccommodationLayer
          range={range}
          data={data}
          setShowRoomType={setShowRoomType}
          showRoomType={showRoomType}
          weekendIndexes={weekendIndexes}
          showChannels={showChannels}
          showChannelsLayer={showChannelsLayer}
          setChannelsLayer={setChannelsLayer}
          getMonitoringRoomTypeData={getMonitoringRoomTypeData}
          inventoryTypeAutocomplete={inventoryTypeAutocomplete}
          statusAutocomplete={statusAutocomplete}
          selectedDateInDatePicker={selectedDateInDatePicker}
          loadingForRoomType={loadingForRoomType}
          currentIndexAccommodationLayer={currentIndexAccommodationLayer}
          setCurrentIndexAccommodationLayer={setCurrentIndexAccommodationLayer}
          accommodationIndex={accommodationIndex}
        />
        <Collapse in={showRoomType}>
          <div>
            <InfiniteScroll
              pageStart={0}
              loadMore={() => {
                setTimeout(() => {
                  setnumberOfVisibleRoomTypes(
                    numberOfVisibleRoomTypes + PAGE_SIZE
                  )
                }, 500)
              }}
              hasMore={
                roomTypeMonitoringUpdate &&
                numberOfVisibleRoomTypes <=
                  roomTypeMonitoringUpdate.data.length - 1
              }
              loader={
                <div key={0} className={classes.loadingContainer}>
                  <CircularProgress size={32} />
                </div>
              }
              useWindow={true}>
              {roomTypeMonitoringUpdate?.data
                .slice(0, numberOfVisibleRoomTypes)
                .map((dataRoomType, indexRoomType) => (
                  <RoomTypeLayer
                    dataRoomType={dataRoomType}
                    key={indexRoomType}
                    range={range}
                    weekendIndexes={weekendIndexes}
                    indexRoomType={indexRoomType}
                    ratePlanMonitoringUpdate={ratePlanMonitoringUpdate}
                    getMonitoringRatePlanData={getMonitoringRatePlanData}
                    inventoryTypeAutocomplete={inventoryTypeAutocomplete}
                    statusAutocomplete={statusAutocomplete}
                    selectedDateInDatePicker={selectedDateInDatePicker}
                    propertyCode={data.propertyCode}
                    loadingForRatePlan={loadingForRatePlan}
                    currentIndex={currentIndex}
                    setCurrentIndex={setCurrentIndex}
                  />
                ))}
            </InfiniteScroll>
          </div>
        </Collapse>
        <Collapse in={showChannelsLayer}>
          <div>
            <InfiniteScroll
              pageStart={0}
              loadMore={() => {
                setTimeout(() => {
                  setnumberOfVisibleChannels(
                    numberOfVisibleChannels + PAGE_SIZE
                  )
                }, 500)
              }}
              hasMore={numberOfVisibleChannels <= data.channels.length - 1}
              loader={
                <div key={0} className={classes.loadingContainer}>
                  <CircularProgress size={32} />
                </div>
              }
              useWindow={true}>
              {data.channels
                .slice(0, numberOfVisibleChannels)
                .map((channel, index) => (
                  <ChannelsLayer
                    key={index}
                    range={range}
                    channel={channel}
                    dataRoomTypeName={data}
                    weekendIndexes={weekendIndexes}
                    showChannelsLayer={showChannelsLayer}
                    roomTypeMonitoringUpdate={roomTypeMonitoringUpdate}
                    ratePlanMonitoringUpdate={ratePlanMonitoringUpdate}
                    getMonitoringRoomTypeData={getMonitoringRoomTypeData}
                    getMonitoringRatePlanData={getMonitoringRatePlanData}
                    inventoryTypeAutocomplete={inventoryTypeAutocomplete}
                    statusAutocomplete={statusAutocomplete}
                    selectedDateInDatePicker={selectedDateInDatePicker}
                    propertyCode={data.propertyCode}
                    loadingForRatePlan={loadingForRatePlan}
                    loadingForRoomType={loadingForRoomType}
                    currentIndexChannelsLayer={currentIndexChannelsLayer}
                    setCurrentIndexChannelsLayer={setCurrentIndexChannelsLayer}
                    channelIndex={index}
                  />
                ))}
            </InfiniteScroll>
          </div>
        </Collapse>
      </div>
    </Paper>
  )
}
